import { render, staticRenderFns } from "./ManagerBaseCandidates.vue?vue&type=template&id=1c764108"
import script from "./ManagerBaseCandidates.vue?vue&type=script&lang=js"
export * from "./ManagerBaseCandidates.vue?vue&type=script&lang=js"
import style0 from "./ManagerBaseCandidates.vue?vue&type=style&index=0&id=1c764108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports